/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpBoardSpace } from './FuelUpBoardSpace';
import {
    FuelUpBoardSpaceFromJSON,
    FuelUpBoardSpaceFromJSONTyped,
    FuelUpBoardSpaceToJSON,
    FuelUpBoardSpaceToJSONTyped,
} from './FuelUpBoardSpace';

/**
 * Represents the Fuel-Up Adventure game board configuration
 * @export
 * @interface FuelUpGameBoard
 */
export interface FuelUpGameBoard {
    /**
     * 
     * @type {string}
     * @memberof FuelUpGameBoard
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameBoard
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpGameBoard
     */
    updatedAt: number;
    /**
     * Board configuration version
     * @type {string}
     * @memberof FuelUpGameBoard
     */
    version: string;
    /**
     * Board name/theme
     * @type {string}
     * @memberof FuelUpGameBoard
     */
    name?: string;
    /**
     * Board description
     * @type {string}
     * @memberof FuelUpGameBoard
     */
    description?: string;
    /**
     * Array of all 48 board spaces
     * @type {Array<FuelUpBoardSpace>}
     * @memberof FuelUpGameBoard
     */
    spaces: Array<FuelUpBoardSpace>;
    /**
     * Whether this board config is active
     * @type {boolean}
     * @memberof FuelUpGameBoard
     */
    isActive: boolean;
    /**
     * Base cost to make a move
     * @type {number}
     * @memberof FuelUpGameBoard
     */
    baseFuelCost?: number;
    /**
     * Fuel amount needed to prestige
     * @type {number}
     * @memberof FuelUpGameBoard
     */
    prestigeThreshold?: number;
    /**
     * Loop level (1-10) for multi-loop progression
     * @type {number}
     * @memberof FuelUpGameBoard
     */
    loopLevel?: number;
    /**
     * RewardConfig IDs granted when completing this loop
     * @type {Array<string>}
     * @memberof FuelUpGameBoard
     */
    loopCompletionRewards?: Array<string>;
    /**
     * ObjectId of next loop board (null for Loop 10)
     * @type {string}
     * @memberof FuelUpGameBoard
     */
    nextLoopBoardId?: string;
}

/**
 * Check if a given object implements the FuelUpGameBoard interface.
 */
export function instanceOfFuelUpGameBoard(value: object): value is FuelUpGameBoard {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('spaces' in value) || value['spaces'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function FuelUpGameBoardFromJSON(json: any): FuelUpGameBoard {
    return FuelUpGameBoardFromJSONTyped(json, false);
}

export function FuelUpGameBoardFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpGameBoard {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'version': json['version'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'spaces': ((json['spaces'] as Array<any>).map(FuelUpBoardSpaceFromJSON)),
        'isActive': json['isActive'],
        'baseFuelCost': json['baseFuelCost'] == null ? undefined : json['baseFuelCost'],
        'prestigeThreshold': json['prestigeThreshold'] == null ? undefined : json['prestigeThreshold'],
        'loopLevel': json['loopLevel'] == null ? undefined : json['loopLevel'],
        'loopCompletionRewards': json['loopCompletionRewards'] == null ? undefined : json['loopCompletionRewards'],
        'nextLoopBoardId': json['nextLoopBoardId'] == null ? undefined : json['nextLoopBoardId'],
    };
}

export function FuelUpGameBoardToJSON(json: any): FuelUpGameBoard {
    return FuelUpGameBoardToJSONTyped(json, false);
}

export function FuelUpGameBoardToJSONTyped(value?: FuelUpGameBoard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'version': value['version'],
        'name': value['name'],
        'description': value['description'],
        'spaces': ((value['spaces'] as Array<any>).map(FuelUpBoardSpaceToJSON)),
        'isActive': value['isActive'],
        'baseFuelCost': value['baseFuelCost'],
        'prestigeThreshold': value['prestigeThreshold'],
        'loopLevel': value['loopLevel'],
        'loopCompletionRewards': value['loopCompletionRewards'],
        'nextLoopBoardId': value['nextLoopBoardId'],
    };
}

